export default "__VITE_ASSET__mEn9rSyu__"